import React from 'react'
import ReactDom from 'react-dom/client'
import App from './App'
import {BrowserRouter} from 'react-router-dom'
import { message } from 'antd'

// 全局 message 配置：延长显示时间至 5 秒
message.config({
  duration: 2,
})

const root = ReactDom.createRoot(document.getElementById('app'))
root.render(
<BrowserRouter>
<App/>
</BrowserRouter>
)

// 热模块替换
if (module.hot) {
  module.hot.accept('./App', () => {
    root.render(
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    )
  })
}